<template>
    <div v-if="itemsWithClosenessQualifiers > 0">
        <div class="sparkle" @click="hupOpenModal({modalId: 'sparkle'})">
            <div class="mr-3">
                <div class="sparkle__icon"></div>
            </div>
            <div class="sparkle__text">
                <div class="sparkle__title">You have {{itemsWithClosenessQualifiers}} {{itemsWithClosenessQualifiers | pluralize('item')}} in your cart that {{itemsWithClosenessQualifiers == 1 ? 'qualifies' : 'qualify'}} for an offer!</div>
                <div class="sparkle__description">Complete {{itemsWithClosenessQualifiers | pluralize('offer')}} to save more!</div>
            </div>
            <div class="sparkle__button-container">
                <button class="btn btn-outline-primary btn-sparkle d-none d-md-block" @click="hupOpenModal({modalId: 'sparkle'})">View Deals</button>
            </div>
        </div>

  </div>
</template>

<script>
export default {
  name: 'CartSparkle',
  props: {
    cartItems: {
      type: Array
    }
  },
  data () {
    return {

    }
  },
  computed: {
    itemsWithClosenessQualifiers: function () {
      var itemCountWithClosenessQualifier = 0

      // Search through each category for items that have a closenessQualifier
      this.cartItems.forEach(function (category) {
        category.items.forEach(function (item) {
          if (item.availableCoupons.length > 0) {
            itemCountWithClosenessQualifier++
          }

          if (item.availablePromotions.length > 0) {
            itemCountWithClosenessQualifier++
          }
        })
      })

      return itemCountWithClosenessQualifier
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/lib";

.sparkle {
  border: 1px solid $color-border-standard-gray;
  border-radius: $border-radius-standard;
  background-color: #fff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  padding: 8px;
}

.sparkle__text{
    flex-grow: 1;
    flex-basis: 100%;
}

.sparkle__title{
    font-weight: bold;
    font-size: 16px;
}

bootstrap button.btn-sparkle{
    padding-left: 32px;
    padding-right: 32px;
    border-color: $color-heb-primary;
}

button.btn-sparkle:focus{
    color: $color-heb-primary;
}

.sparkle__icon {
    width: 28px;
    height: 28px;
    background: url('https://images.heb.com/is/image/HEBGrocery/closeness-qualifier-sprite@2x?$article$') no-repeat;
    background-size: 28px;
}

.sparkle-in-modal{
    display: flex;
    margin-bottom: 32px;
}

#view-deals-modal .cart-item__note-sub-mobile,
#view-deals-modal .cart-item__substitution,
#view-deals-modal .cart-item__note{
    display: none !important;
}


@media screen and (min-width: $breakpoint-tablet) {
  .sparkle__button-container {
    flex-basis: 220px;
  }
}
</style>

<docs>
</docs>
